import { useEffect } from 'react';
import Hero from './components/Hero';
import Navigation from './components/Navigation';
import ServicesGrid from './components/ServicesGrid';
import Contact from './components/Contact';
import Footer from '../home/components/Footer';
import { useSchemaOrg } from '../../utils/seo';

export default function BrandingDigitalStrategy() {
  // Add WebPage Schema
  useSchemaOrg({
    type: 'WebPage',
    data: {
      name: 'Branding & Digital Strategy Services - Yepes WebLab',
      description: 'Professional branding and digital strategy services. Brand identity, market positioning, and strategic planning that drives business growth.',
      url: `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/branding-digital-strategy`,
    },
  });

  // Add Service Schema for Branding & Digital Strategy
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
    
    const serviceSchema = {
      '@context': 'https://schema.org',
      '@type': 'ItemList',
      itemListElement: [
        {
          '@type': 'Service',
          position: 1,
          name: 'Brand Identity Design',
          description: 'Complete brand identity systems including logos, color palettes, typography, and visual guidelines that define your unique presence.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 2,
          name: 'Digital Strategy',
          description: 'Comprehensive digital strategies that align with your business goals and drive measurable results across all channels.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
        {
          '@type': 'Service',
          position: 3,
          name: 'Market Positioning',
          description: 'Strategic positioning that differentiates your brand in the market and resonates with your target audience.',
          provider: {
            '@type': 'Organization',
            name: 'Yepes WebLab',
            url: siteUrl,
          },
          areaServed: 'Worldwide',
        },
      ],
    };

    const scriptId = 'schema-branding-services';
    let scriptTag = document.getElementById(scriptId);

    if (!scriptTag) {
      scriptTag = document.createElement('script');
      scriptTag.id = scriptId;
      scriptTag.type = 'application/ld+json';
      document.head.appendChild(scriptTag);
    }

    scriptTag.textContent = JSON.stringify(serviceSchema);

    return () => {
      const existingScript = document.getElementById(scriptId);
      if (existingScript) {
        existingScript.remove();
      }
    };
  }, []);

  return (
    <div className="min-h-screen bg-[#EBEBE0]">
      <Navigation />
      <Hero />
      <ServicesGrid />
      <Contact />
      <Footer />
    </div>
  );
}
